export default __webpack_public_path__ + "static/media/pod.30776f82.jpg";